import React, { useEffect, useRef, createElement } from 'react';
import { XIcon } from 'lucide-react';
interface TypeformModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TypeformModal({
  isOpen,
  onClose
}: TypeformModalProps) {
  const scriptLoaded = useRef(false);
  useEffect(() => {
    if (isOpen && !scriptLoaded.current) {
      const script = document.createElement('script');
      script.src = '//embed.typeform.com/next/embed.js';
      script.async = true;
      document.body.appendChild(script);
      scriptLoaded.current = true;
    }
  }, [isOpen]);
  // Re-initialize Typeform when modal opens
  useEffect(() => {
    if (isOpen && scriptLoaded.current) {
      // Give DOM time to render, then trigger Typeform re-init
      const timer = setTimeout(() => {
        if ((window as any).tf) {
          ;
          (window as any).tf.load();
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-111">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-112" />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-2xl bg-[#0d1117] border border-[#2d3748] rounded-2xl overflow-hidden shadow-2xl" style={{
      height: '80vh',
      maxHeight: '700px'
    }} onClick={e => e.stopPropagation()} data-id="element-113">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 right-4 z-20 p-2 rounded-full bg-[#1a1f2e] text-[#a0aec0] hover:text-white hover:bg-[#2d3748] transition-colors" aria-label="Close" data-id="element-114">
          <XIcon className="w-5 h-5" data-id="element-115" />
        </button>

        {/* Typeform embed */}
        <div className="w-full h-full" data-id="element-116">
          <div data-tf-live="01KHYB889RR3GZZDW58HES4J3C" style={{
          width: '100%',
          height: '100%'
        }} data-id="element-117" />
        </div>
      </div>
    </div>;
}